module.exports = __webpack_public_path__ + "fonts/NunitoSans-Italic.2aaa431.woff2";